import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface sendVerificationCodeProps extends CacheProps {
  mobile: string
  type: string
}

const sendVerificationCode = ({ mobile, type, ...rest }: sendVerificationCodeProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.client.validation-code'],
    payload: {
      mobile: mobile,
      type: type,
      otp_client_type: 3,
      client_secret: 'OTP-APP_6Q9OZYk8ognAPP',
    },
    ...rest,
  });
};

export default sendVerificationCode;
